import { AccountDetails } from 'core/cuenta/components/AccountDetails/AccountDetails';
import { AccountMovementsList } from 'core/cuenta/components/AccountMovementsList/AccountMovementsList';
import { AccountDetailsContext } from 'core/cuenta/contexts/AccountDetailsContext';
import { useContext } from 'react';
import { Alert, Col, Container, Row } from 'react-bootstrap';
import { LinkButton } from 'shared/components';

export function AccountTotalsDataPage() {
  const { accountData, closeReport, searchParams } = useContext(AccountDetailsContext);

  return (
    <Container>
      {accountData && accountData.movimientos ? (
        <>
          <Row className="mb-3">
            <Col>
              <AccountDetails accountData={accountData} periodo={searchParams} />
            </Col>
          </Row>
          <Alert className="text-center">
            Los movimientos que se visualizan corresponden a ingresos y egresos de la
            cuenta por transferencia.
          </Alert>
          <AccountMovementsList />
        </>
      ) : (
        <Alert className="text-center">
          No hay movimientos en el período para esta cuenta
        </Alert>
      )}
      <Row className="text-center">
        <Col>
          <LinkButton onClick={closeReport}>Volver</LinkButton>
        </Col>
      </Row>
    </Container>
  );
}
